import { TableModel } from 'components/table/IdmTable';
import { format, parseISO } from 'date-fns';

export type DeliveriesStatsElement = {
  courierId: number;
  date: string;
  pastETADeliveriesCount: number;
  outOfOrderDeliveriesCount: number;
  delivered: number;
  totalDeliveries: number;
  onClickHandler: () => void;
};

const deliveriesStatsmodel: TableModel<DeliveriesStatsElement> = {
  columns: [
    {
      title: 'Courier Id',
      html: (e: DeliveriesStatsElement) => <span>{e.courierId}</span>,
    },
    {
      title: 'Itinerary Details',
      html: (e: DeliveriesStatsElement) => (
        <span>
          <button type="button" onClick={e.onClickHandler}>
            View itinerary details
          </button>
        </span>
      ),
    },
    {
      title: 'Date',
      html: (e: DeliveriesStatsElement) => (
        <span>{format(parseISO(e.date), 'dd-MM-yyyy')}</span>
      ),
    },
    {
      title: 'Past ETA Deliveries Count',
      html: (e: DeliveriesStatsElement) => (
        <span className={e.pastETADeliveriesCount > 1 ? 'text-red' : ''}>
          {e.pastETADeliveriesCount}
        </span>
      ),
    },
    {
      title: 'Out of Order Deliveries Count',
      html: (e: DeliveriesStatsElement) => (
        <span>{e.outOfOrderDeliveriesCount}</span>
      ),
    },
    {
      title: 'Delivered AWBs',
      html: (e: DeliveriesStatsElement) => <span>{e.delivered}</span>,
    },
    {
      title: 'Total AWBs',
      html: (e: DeliveriesStatsElement) => <span>{e.totalDeliveries}</span>,
    },
  ],
};

export default deliveriesStatsmodel;
